<template functional>
  <a
    v-if="props.url"
    :href="props.url"
    :target="newTab ? '_blank' : none"
    :class="[props.type, props.size, data.staticClass]"
    class="btn button"
    :style="`--fontSize: ${props.fontSize};`"
    v-bind="data.attrs"
  >
    <!-- @slot Content within button -->
    <slot>
      {{ props.label }}
    </slot>
  </a>
  <button
    v-else
    :class="[props.type, props.size, data.staticClass]"
    class="btn button"
    :style="`--fontSize: ${props.fontSize};`"
    v-bind="data.attrs"
    v-on="listeners.click ? { click: listeners.click } : null"
  >
    <!-- @slot Content within button -->
    <slot>
      <span v-if="props.label">
        {{ props.label }}
      </span>
    </slot>
  </button>
</template>

<script>
export default {
  props: {
    /** Font-size of button */
    fontSize: {
      type: String,
      default: '16px'
    },
    /** Label of button */
    label: {
      default: '',
      type: String
    },
    /** Open in new tab on click */
    newTab: {
      type: Boolean,
      default: false
    },
    /** Size of button */
    size: {
      default: '',
      type: String,
      validator(value) {
        return ['', 'btn-sm', 'btn-lg', 'is-fullwidth'].indexOf(value) !== -1
      }
    },
    /** Type of button */
    type: {
      type: String,
      default: 'btn-default',
      validator: function (value) {
        return (
          [
            'btn-default',
            'btn-white',
            'btn-primary',
            'btn-grey',
            'btn-disabled',
            'btn-clear',
            'btn-icon',
            'btn-text'
          ].indexOf(value) !== -1
        )
      }
    },
    /** Link to redirect to on-click */
    url: {
      default: '',
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/elements/button';

@mixin button-variant($color, $background, $border, $opacity) {
  color: $color;
  background-color: $background;
  border-color: $border;

  &:hover,
  &:active,
  &:focus {
    color: $color;
    opacity: $opacity;
    border-color: $border;
    box-shadow: none !important;
  }
}

.btn {
  font-weight: 700;
  text-transform: uppercase;
  border-radius: 0;
  padding: 13px 15px 9px;
  font-size: var(--fontSize);
  line-height: 16px;
  color: $white;
}

a {
  color: inherit;

  &:hover {
    text-decoration: none;
  }
}

.btn-sm {
  font-size: 14px;
  line-height: 14px;
  padding: 7px 10px 5px;
}

.btn-lg {
  height: 3em;
}

.btn-default {
  @include button-variant($white, $black, $black, 0.8);
}

.btn-primary {
  @include button-variant($white, $red, $red, 0.8);
}

.btn-white {
  @include button-variant($black, $white, $black, 0.7);
}

.btn-grey {
  @include button-variant($white, $grey-dark, $grey-dark, 0.8);
}

.btn-disabled {
  @include button-variant($grey, $grey-light, $grey-light, 1);
  pointer-events: none;
}

.btn-clear {
  @include button-variant($black, transparent, transparent, 1);
  text-transform: lowercase;
}

.btn-icon {
  @extend .btn-clear;
  padding: 0;
}

.btn-text {
  @include button-variant($grey-darker, $white, transparent, 1);
  font-weight: normal;
  height: 25px;
  padding: 2px 8px;
  text-transform: none;
  &:hover {
    background: $grey-dark;
    color: $white;
  }
}

.btn-link {
  &:hover {
    color: $red-light;
  }
}
</style>
